import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';

interface DayProps {
    date: string;
    base: boolean;
    isLoading: boolean;
    selected: boolean;
    bookable: boolean;
    setSelected: (value: string) => void;
    setDate: (date: moment.Moment) => void;
}

interface DayState {
    selectable: boolean;
    selected: boolean;
}

export const CalendarBox: React.FC<DayProps> = (props: DayProps) => {
    const date = moment(props.date);
    const [state, setState] = useState<DayState>({
        selectable: props.bookable,
        selected: props.selected,
    });

    useEffect(() => {
        setState({
            selectable: props.bookable,
            selected: props.selected,
        });
    }, [props]);

    const handleClick = (_e: any) => {
        if (!props.isLoading && state.selectable && !props.base && !state.selected) {
            props.setSelected(props.date);
            props.setDate(date); // set newCheckIn or newCheckOut
        }
    };

    const linkReferences = {
        wrapperRef: useRef<any>(),
    };

    return (
        <div
            id={`box_${date.unix()}`}
            className={`
            d-flex box
            ${props.base ? 'calendar-base-date' : ''}
            ${state.selectable ? 'calendar-selectable-date' : 'calendar-disabled-date'}
            ${state.selected ? 'calendar-selected-date' : ''}
            `}
            onClick={(event) => handleClick(event)}
            ref={linkReferences.wrapperRef}
        >
            <div id={`box_${date.unix()}_description`} className={`font-dates-calendar d-flex flex-column`}>
                <span>{date.format('ddd')}</span>
                <span>{date.format('DD')}</span>
            </div>
        </div>
    );
};
